import { render, staticRenderFns } from "./output - 副本.vue?vue&type=template&id=b8d2f7ba"
import script from "./output - 副本.vue?vue&type=script&lang=js"
export * from "./output - 副本.vue?vue&type=script&lang=js"
import style0 from "./output - 副本.vue?vue&type=style&index=0&id=b8d2f7ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports